var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":"","color":"#EAF8F1"}},[_c('fulfilling-bouncing-circle-spinner',{attrs:{"animation-duration":3000,"size":60,"color":"#0A9971"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }